import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        document.title = '5AM PADEL CLUB VISION';
    }, [location]);

    return null;
};

export default TitleUpdater;
